import {useDispatch} from "react-redux";
import {
  Container,
  Wrapper,
} from "./styledComponents";
import {useEffect, useState} from "react";
import { Header } from "../../layout";
import {getCity, getListGroup, getUserInfoActionCreator, postStudentImport} from "../../../../api/UserAPI";
import Select from "react-select";
import { RememberContainer, StyledButton} from "../../../../pages/Login/LoginForm/styledComponents";
import {Loader} from "../../../../components";
import {useHistory} from "react-router";
import {setCityId, setGroupId} from "../../../../reducers/userInfo";

const citiesPage = 1;

export const AddDataCityModal = () => {
  const dispatch = useDispatch();
  const [cities, setCities] = useState<any[]>([]);
  const [groups, setGroups] = useState([])
  const [load, setLoad] = useState(false);
  const history = useHistory();

  const [group, setGroup] = useState(null)
  const [city, setCity] = useState(null)

  useEffect(() => {
    const getData = async () => {
      try {
        const {data} = await getListGroup()

        if (data) {
          setGroups(data.items.map((item: any) => ({value: item.id, label: item.name})))
        }
      } catch (e) {
        console.log(e)
      }
    }

    if (groups.length === 0) {
      getData()
    }
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const resp = await getCity(1550, citiesPage);
        const newArr: any[] = resp.data.items.map((item: any) => ({value: item.id, label: item.name})).sort((a: any,b : any) => {
          if (a.label.toLowerCase() < b.label.toLowerCase()) {
            return -1;
          }
          if (a.label.toLowerCase() > b.label.toLowerCase()) {
            return 1;
          }
          return 0;
        });

        // if (citiesPage === 0) {
        //   setCities([{value: '-', label: '-'},...newArr])
        // } else {
          setCities([...cities,...newArr])

        // }

      } catch (e) {
        console.log(e)
      }

    }
    getData()
  }, [citiesPage]);

  const onSend = async () => {
    try {
      setLoad(true);
      await postStudentImport({
        group_id: group,
        city_id: city,
      })

      dispatch(setGroupId(group));
      dispatch(setCityId(city));

      dispatch(getUserInfoActionCreator(history.push));
      setLoad(false);
    } catch (e) {
      setLoad(false);
    }
  }


  return (
    <Wrapper>
      <Container>
        <Header
            font={"heading6FontSize"}
            title={'Требуется заполнить данные'}
            // onClose={handleClose}
        />
        <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
          {load ?<div style={{height: 100}}> <Loader /> </div>:
              <>
                <Select placeholder='Выбрать город' options={cities}
                        onChange={(e: any) => {
                          setCity(e.value)
                        }}/>

                <Select placeholder='Выбрать группу' options={groups}
                        onChange={(e: any) => {
                          setGroup(e.value)
                        }}/>
             </>
          }
          </div>
        <RememberContainer>
          <StyledButton onClick={onSend} disabled={load || group === null || city === null} type="submit">Сохранить</StyledButton>
        </RememberContainer>
      </Container>
    </Wrapper>
  );
};
